import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function saveDeliveryCycle({
  name,
  deadline,
  company_id,
  company_de,
  operationcenter_id,
  file_type_id,
  data_operacao,
  type,
  user_id,
  referencia,
}) {
  try {
    const response = await authHttp().post(routes.urlPostDeliveryCycle, {
      name,
      deadline: parseToMysqlFormat(deadline),
      company_id,
      company_de,
      operationcenter_id,
      file_type_id,
      data_operacao: data_operacao ? parseToMysqlFormat(data_operacao) : null,
      type: type,
      user_id,
      referencia,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateDeliveryCycle({
  id,
  name,
  deadline,
  company_id,
  company_de,
  operationcenter_id,
  file_type_id,
  data_operacao,
  type,
  referencia,
}) {
  try {
    const response = await authHttp().put(routes.urlDeliveryCycle(id), {
      name,
      deadline: parseToMysqlFormat(deadline),
      company_id,
      company_de,
      operationcenter_id,
      file_type_id,
      data_operacao: data_operacao ? parseToMysqlFormat(data_operacao) : null,
      type: type,
      referencia,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesCyclesByNF(
  centralId,
  initialPeriod,
  finalPeriod,
  companyId,
  notaFiscal,
) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesCyclesByNF(
        centralId,
        initialPeriod,
        finalPeriod,
        companyId,
        notaFiscal,
      ),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesCycles(centralId, initialPeriod, finalPeriod) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesCycles(centralId, initialPeriod, finalPeriod),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteDeliveryCycle(cycle_id) {
  try {
    const response = await authHttp().delete(routes.urlDeliveryCycle(cycle_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDeliveriesCyclesByIds(cyclesIds) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveriesCycleByIds(cyclesIds))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
